import { GlobalSettings } from './game'
import { Schema$UserInfo } from '../interface/common'

export enum PORTAL_SOCKET_EVENT {
  UPDATE_USER_ASSETS = 'updateUserAssets',
  REGISTER_CLIENT = 'registerClient',
  DUPLICATE_LOGIN_EXCEPTION = 'duplicateLoginException',
  UPDATE_GLOBAL = 'updateGlobal',
  PUSH_BET_RESULT = 'pushBetResult',
  KICK = 'kick',
  RECEIVE_CLUB_MESSAGE = 'receiveClubMessage',
  RECEIVE_USER_MESSAGE = 'receiveUserMessage',
  UPDATE_LIVE_MATCH_COUNT = 'updateLiveMatchCount',
  UPDATE_USER_PLAY_BLOCK_TIME = 'updateUserPlayBlockTime',
  UPDATE_BETTING_TOTAL_COUNT = 'updateBettingTotalCount',
  RECEIVE_URGENCY_MESSAGE = 'receiveUrgencyMessage',
  UPDATE_MATCHUP_NOTICE = 'updateMatchupNotice',
  DELETE_MATCHUP_NOTICE = 'deleteMatchupNotice',
  ON_REGISTER_MATCH_TIMELINE_WATCHING = 'onRegisterMatchTimelineWatching',
  GET_REALTIME_LIVE_SCORE_MATCH_IDS_BY_BETTING_HISTORY = 'getRealTimeLiveScoreMatchIdsByBettingHistory',
  ON_REALTIME_LIVE_SCORE_MATCH_IDS_BY_BETTING_HISTORY = 'onRealTimeLiveScoreMatchIdsByBettingHistory',
  UPDATE_MY_ACTIVITY_INFO = 'updateMyActivityInfo',
  ON_SIMPLE_LIVE_MATCH_LIST = 'simpleMatchTimelineGroupList',
  UPDATE_POPULAR_SEARCH_TERM = 'updatePopularSearchTerm',
  DELETE_POPULAR_SEARCH_TERM = 'deletePopularSearchTerm',
  UPDATE_POPULAR_SEARCH_TERM_LIST = 'updatePopularSearchTermList',
  DELETE_POPULAR_SEARCH_TERM_LIST = 'deletePopularSearchTermList',
  UPDATE_HOME_MAIN_BANNER = 'updateHomeMainBanner',
  DELETE_HOME_MAIN_BANNER = 'deleteHomeMainBanner',
  REFRESH_USER_PROFILE_IMAGE = 'refreshUserProfileImage',
}

// export enum CHAT_SOCKET_EVENT {
//   VISIBLE_CHAT = 'visibleChatMessage',
//   INVISIBLE_CHAT = 'invisibleChatMessage',
//   VISIBLE_CHAT_MEMBER_COUNT = 'visibleChatMemberCount',
//   MESSAGE = 'chatMessage',
//   ALL_MESSAGE = 'allChatMessage',
//   UPLOAD_IMAGE = 'uploadImage', // v2-api 서버 호출로 변경 할것.
//   UPLOAD_PROFILE_IMAGE = 'uploadProfileImage', // v2-api 서버 호출로 변경 할것.
//   ALL_MY_REPLY_MESSAGE = 'allMyReplyMessage',
//   ALL_SHARED_BET_HISTORY_MESSAGE = 'allSharedBetHistoryMessage',
//   UPDATE_CHAT_MESSAGE = 'updateChatMessage',
//   UPDATE_USER_PROFILE_IMAGE = 'updateUserProfileImage',
//   ERROR_MESSAGE = 'chatErrorMessage',
//   VISIBLE_CHAT_COUNT_INFO = 'visibleChatCountInfo',
//   PRE_DISCONNECT = 'preDisconnect',
// }

export type RegisterClientPacket = number

export type UpdateGlobalPacket = GlobalSettings[]

export type PushBetResultPacket = {
  userId: string
  errObj?: {
    errcode: number
  }
  userInfo: Schema$UserInfo
}
